<script lang="ts">
  import { Link } from "svelte-routing";
  import { betaEnabled } from "./beta";
</script>

<footer class="site-foot">
  <div class="wrap">
    <div class="foot-grid">
      <div class="foot-col">
        <Link to="/" class="brand" style="font-size:20px; margin-bottom:14px">
          <img
            class="mark"
            src="/icon-wiederdabei.svg"
            alt=""
            width="30"
            height="30"
            style="width:30px;height:30px"
          />
          <span>wiederdabei</span>
        </Link>
        <p style="color:var(--muted); font-size:15px; max-width:34ch">
          Unterricht live nach Hause, selbst gehostet — damit kein
          langzeiterkranktes Kind den Anschluss an seine Klasse verliert. Wieder
          dabei — wenigstens digital.
        </p>
      </div>

      <div class="foot-col">
        <h4>Entdecken</h4>
        <Link to="/avatar">Was ist ein Avatar</Link>
        <Link to="/projekt">Projekt</Link>
        <Link to="/jetzt-starten">Jetzt starten</Link>
        <Link to="/self-hosted">Self-Hosted</Link>
        <Link to="/schule-behoerden">Schule & Behörden</Link>
      </div>

      <div class="foot-col">
        <h4>Open Source</h4>
        <a href="https://git.buss-labs.de/wiederdabei/avatar">Repository</a>
        <a href="https://git.buss-labs.de/wiederdabei/avatar/issues">Issues</a>
        <a href="https://student.wiederdabei.de">Avatar-Login: Schüler</a>
        <a href="https://admin.wiederdabei.de">Avatar-Login: Admin</a>
      </div>

      <div class="foot-col">
        <h4>Kontakt & Recht</h4>
        <Link to="/kontakt">Kontakt</Link>
        <Link to="/demo">Demo</Link>
        {#if $betaEnabled}<Link to="/beta">Beta-Phase</Link>{/if}
        <Link to="/impressum">Impressum</Link>
        <Link to="/datenschutz">Datenschutz</Link>
      </div>
    </div>

    <div class="foot-bottom">
      <span
        >© 2026 wiederdabei · ein Projekt der Buss IT-Labs GmbH · Lizenz:
        AGPL-3.0</span
      >
      <span class="mono">wieder dabei.</span>
    </div>
  </div>
</footer>
